import * as Yup from 'yup';
import { AmenityChargeFrequency } from 'models/Amenity';

export const editSchema = () =>
  Yup.object({
    chargeFrequency: Yup.mixed<AmenityChargeFrequency | null>()
      .oneOf([null, ...Object.values(AmenityChargeFrequency)])
      .transform((value) => (value === '' ? null : value))
      .nullable(),
    description: Yup.string().max(1000).nullable(),
    price: Yup.number()
      .useNaNAsNull()
      .useNegativeZeroAsNegative()
      .moreThan(0)
      .nullable(),
  });

export type EditModalSchemaType = Yup.InferType<ReturnType<typeof editSchema>>;
